import axios from '@axios'
import { storePagination, sorting } from '@/mixins'

const getInitialState = () => ({
  ...storePagination.state(),
  filters: {
    nsuGetnet: null,
    nsuErp: null,
    value: null,
    status: null,
    inputMethod: null,
    acquirerProductId: null,
    paymentMethodIdErp: null,
  },
  reconciliation: {
    id: null,
    checkingAccount: {
      id: null,
      name: null,
    },
    movementDate: null,
    percentCommissionTax: null,
    status: null,
  },
  summaryFields: {
    erpTotalValue: {},
    stripeTotalValue: {},
    stripeTotalCommission: {},
  },
  reconciliationItems: [],
})

export default {
  namespaced: true,
  state: getInitialState(),
  mutations: {
    ...storePagination.mutations,
    SET_RECONCILIATION(state, reconciliation) {
      state.reconciliation = reconciliation
    },
    SET_RECONCILIATION_ITEMS(state, items) {
      state.reconciliationItems = items
    },
    SET_SUMMARY_FIELDS(state, summaryFields) {
      state.summaryFields = summaryFields
    },
    SET_FILTERS(state, filters) {
      state.filters = filters
    },


    CLEAN_STATE(state) {
      const {
        reconciliation,
        reconciliationItems,
        reconciliationFile,
        filters,
      } = getInitialState()
      state.reconciliation = reconciliation
      state.reconciliationItems = reconciliationItems
      state.reconciliationFile = reconciliationFile
      state.filters = filters
    },
  },
  actions: {
    ...storePagination.actions,
    cleanState({ commit }) {
      commit('CLEAN_STATE')
    },
    async fetchReconciliation({ commit }, id) {
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}`)
      commit('SET_RECONCILIATION', data)
    },
    async fetchReconciliationItems({ commit, state }, id) {
      // const { filters } = state

      // const filterValue = new Decimal(filters.value || 0).times(100).toNumber()

      const params = {
        // nsuGetnet: filters.nsuGetnet,
        // nsuErp: filters.nsuErp,
        // status: filters.status,
        // inputMethod: filters.inputMethod,
        // acquirerProductId: filters.acquirerProductId,
        // paymentMethodIdErp: filters.paymentMethodIdErp,
        // value: filterValue || undefined,
        sortBy: sorting.methods.getSorting(state),
        pageSize: state.paging.pageSize,
        pageIndex: state.paging.currentPage - 1,
      }
      const { data } = await axios.get(`/api/financial/reconciliation/stripe/${id}/items`, {
        params,
      })
      commit('SET_RECONCILIATION_ITEMS', data.results)
      commit('SET_SUMMARY_FIELDS', data.summaryFields)
      commit('SET_PAGING', {
        ...state.paging,
        rowCount: data.rowCount || 0,
        rowsInCurrentPage: data.rowsInCurrentPage || 0,
      })
    },
    // async fetchAllReconciliationItems({ commit }, id) {
    //   const params = {
    //     pageSize: 99999999,
    //     pageIndex: 0,
    //   }
    //   const { data } = await axios.get(`/api/financial/reconciliation/getnet/${id}/items`, {
    //     params,
    //   })
    //   commit('SET_ALL_RECONCILIATION_ITEMS', data.results)
    // },
    resetFilters({ commit }) {
      commit('SET_CURRENT_PAGE', 1)
      commit('SET_FILTERS', getInitialState().filters)
    },
  },
}
